export const detailWindowIndexes = (index, length) =>
  [-1, 1, 2, 3]
    .map((offset) => index + offset)
    .filter((candidate) => candidate >= 0 && candidate < length);

export function createMlbDetailLoader({ load, cache, concurrency = 2 }) {
  const inflight = new Map();
  let queue = [];
  let backgroundActive = 0;
  let scope = 0;

  const start = (key, row, version, background, jobScope) => {
    if (cache.has(key)) return Promise.resolve(cache.get(key));
    if (inflight.has(key)) return inflight.get(key);
    if (background && jobScope !== scope) return Promise.resolve(null);
    if (background) backgroundActive += 1;
    const promise = Promise.resolve(load(row, version))
      .then((detail) => {
        if (detail) cache.set(key, { ...detail, __pwgVersion: version });
        return cache.get(key) || null;
      })
      .finally(() => {
        inflight.delete(key);
        if (background) backgroundActive -= 1;
        pump();
      });
    inflight.set(key, promise);
    return promise;
  };

  const pump = () => {
    while (backgroundActive < concurrency && queue.length) {
      const job = queue.shift();
      if (job.scope !== scope || cache.has(job.key) || inflight.has(job.key)) continue;
      start(job.key, job.row, job.version, true, job.scope).catch(() => {});
    }
  };

  return {
    selected(key, row, version) {
      queue = queue.filter((job) => job.key !== key);
      return start(key, row, version, false, scope);
    },
    prefetch(key, row, version) {
      if (!key || cache.has(key) || inflight.has(key) || queue.some((job) => job.key === key)) return;
      queue.push({ key, row, version, scope });
      pump();
    },
    reset() {
      scope += 1;
      queue = [];
    },
    stats() {
      return { queued: queue.length, inflight: inflight.size, backgroundActive, scope };
    },
  };
}
